<template>
  <div>
    <set-card v-if="!form.new_time_changes" id="rok" :title="$t('settings_shell.deadlines.title')">
      <div class="ss-empty">
        <span class="ss-empty__i"><v-icon size="26">mdi-history</v-icon></span>
        <b>{{ $t("settings_shell.deadlines.legacy_title") }}</b>
        <p>{{ $t("settings_shell.deadlines.legacy_text") }}</p>
        <button type="button" class="ui-btn ui-btn--primary" @click="ctl.enableNewTimes()">
          {{ $t("settings_shell.deadlines.legacy_button") }}
        </button>
      </div>
    </set-card>

    <div v-else class="ss-g" :class="ctl.isPhone ? 'ss-g1' : 'ss-g2'">
      <div class="ss-gm">
        <set-card id="rok" :title="$t('settings_shell.deadlines.title')" :desc="$t('settings_shell.deadlines.desc')">
          <set-quick-bar />
          <p class="ss-how">
            <v-icon size="16">mdi-information-outline</v-icon>
            <span>{{ $t("settings_shell.deadlines.how") }}</span>
          </p>
          <set-day-rows kind="days" />
        </set-card>
        <set-card id="izuzeci" :title="$t('settings_shell.deadlines.exceptions')">
          <set-switch path="no_time_limit" :title="$t('settings_shell.deadlines.no_limit')" :desc="$t('settings_shell.deadlines.no_limit_d')" />
        </set-card>
      </div>
      <aside class="ss-gs"><set-simulation kind="days" /></aside>
    </div>
  </div>
</template>

<script>
import SetCard from "../parts/SetCard.vue";
import SetSwitch from "../parts/SetSwitch.vue";
import SetDayRows from "../parts/SetDayRows.vue";
import SetQuickBar from "../parts/SetQuickBar.vue";
import SetSimulation from "../parts/SetSimulation.vue";

/** Rokovi: krajnji rok po danima (sa brzim podešavanjem i kalendarom "Šta radnik vidi") i izuzeci od rokova. */
export default {
  name: "ScreenDeadlines",
  components: { SetCard, SetSwitch, SetDayRows, SetQuickBar, SetSimulation },
  inject: { ctl: "settingsCtl" },
  computed: {
    form() {
      return this.ctl.form;
    },
  },
};
</script>
